module.exports = __webpack_public_path__ + "img/Feature-4.533a5ee.svg";